import ShoppingBag from '../../src/legacy/ShoppingBag';
export default ShoppingBag;
